import Vue from 'vue'
import Router from 'vue-router'
import $store from '../store/index.js'

Vue.use(Router)
// meta:{title:''}, 
const routes = [
  {
    path: '/',
    name: 'home',
    component:resolve => require(['@/pages/home/home.vue'], resolve)
  },
  {
    path: '/careers',
    name: 'careers',
    meta:{title:'Careers'}, 
    component:resolve => require(['@/pages/careers/careers.vue'], resolve)
  },
  {
    path: '/contactus',
    name: 'contactus',
    meta:{title:'Contact Us'}, 
    component:resolve => require(['@/pages/contactus/contactus.vue'], resolve)
  },
  {
    path: '/whatwedo',
    name: 'whatwedo',
    meta:{title:'What We Do'}, 
    component:resolve => require(['@/pages/whatwedo/whatwedo.vue'], resolve)
  },
  {
    path: '/whoweare',
    name: 'whoweare',
    meta:{title:'Who We Are'}, 
    component:resolve => require(['@/pages/whoweare/whoweare.vue'], resolve)
  },
  {
    path: '/insights',
    name: 'insights',
    meta:{title:'Insights'}, 
    component:resolve => require(['@/pages/insights/insights.vue'], resolve)
  },
  {
    path: '/announcement',
    name: 'announcement',
    meta:{title:'announcement'}, 
    component:resolve => require(['@/pages/sujufuwu/tonggao.vue'], resolve)
  },
];

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  routes,
  // 部署更改
  base: '/qmisAssetManagement',//测试 /investmentbank  正式 /qmisibcom
  // config 文件夹下 index.js 文件 assets文件 axiosconfig.js文件
  mode: 'history',
  // scrollBehavior(to,from,savedPosition){
  //   console.log(savedPosition)
  //   if(savedPosition){
  //     return savedPosition
  //   }else{
  //     return {
  //       x:0,
  //       y:0
  //     }
  //   }
  // }
})

// routers = new Router({
router.beforeEach((to, from, next) => {
  if(to.name !=='publicholidays' && window.sessionStorage['p_days']){
    window.sessionStorage['p_days'] = ''
  }
  $store.commit('upisland',true)
  setTimeout(()=>{
    $store.commit('upisland',false)
  },500)

  if(to.meta.title){
    document.title = to.meta.title + ' | QMIS ASSET MANAGEMENT LIMITED'
  }else{
    document.title = 'QMIS ASSET MANAGEMENT LIMITED'
  }
  // if(!window.localStorage.token&&from.path !=='/'){
  //   location.href = '/'
  //   next()
  // }else{
  next()
  // }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js